var _path, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcmBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 17.6501V9.66672H6.86668V17.6501H5.2ZM11.2334 17.6501V9.66672H12.9V17.6501H11.2334ZM2 20.9834V19.3167H22V20.9834H2ZM17.1333 17.6501V9.66672H18.8V17.6501H17.1333ZM2 8.00007V6.4501L12 0.983398L22 6.4501V8.00007H2ZM5.71665 6.33342H18.2834L12 2.8834L5.71665 6.33342Z",
    fill: "#5D616D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 18,
    r: 5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2723_34571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9976 18.0189C18.5628 18.0189 18.2025 17.876 17.9167 17.5902C17.6309 17.3044 17.488 16.9441 17.488 16.5093C17.488 16.0745 17.6309 15.7143 17.9167 15.4286C18.2025 15.1429 18.5628 15 18.9976 15C19.4324 15 19.7935 15.1429 20.0809 15.4286C20.3683 15.7143 20.512 16.0745 20.512 16.5093C20.512 16.9441 20.3683 17.3044 20.0809 17.5902C19.7935 17.876 19.4324 18.0189 18.9976 18.0189ZM16 21.1678V20.1243C16 19.881 16.0623 19.6662 16.1868 19.4799C16.3113 19.2935 16.4738 19.1517 16.6743 19.0544C17.071 18.8705 17.4604 18.7323 17.8425 18.6398C18.2246 18.5473 18.6096 18.501 18.9974 18.501C19.3917 18.501 19.7787 18.548 20.1585 18.6419C20.5382 18.7359 20.924 18.8732 21.3159 19.0539C21.5222 19.1486 21.6877 19.2889 21.8126 19.475C21.9375 19.6611 22 19.8772 22 20.1233V21.1678H16ZM16.787 20.3809H21.2097V20.1455C21.2097 20.0627 21.1854 19.9847 21.1367 19.9114C21.0881 19.838 21.0271 19.7831 20.9537 19.7466C20.6083 19.5812 20.2804 19.464 19.97 19.3949C19.6595 19.3259 19.3351 19.2914 18.9966 19.2914C18.665 19.2914 18.3397 19.3259 18.0207 19.3949C17.7018 19.464 17.3744 19.581 17.0384 19.746C16.964 19.7826 16.9035 19.8376 16.8569 19.911C16.8103 19.9844 16.787 20.0626 16.787 20.1455V20.3809ZM18.9976 17.2319C19.2037 17.2319 19.3759 17.163 19.5142 17.0251C19.6525 16.8872 19.7216 16.7151 19.7216 16.5088C19.7216 16.3016 19.6527 16.1295 19.515 15.9925C19.3772 15.8555 19.2052 15.787 18.9991 15.787C18.7929 15.787 18.6207 15.8556 18.4824 15.9929C18.3441 16.1302 18.275 16.3016 18.275 16.5071C18.275 16.7139 18.3439 16.8864 18.4817 17.0246C18.6195 17.1628 18.7914 17.2319 18.9976 17.2319Z",
    fill: "#5D616D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2723_34571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcmBank);
export default __webpack_public_path__ + "static/media/RCMBank.e01c73424ac362dad0c70d72795f718f.svg";
export { ForwardRef as ReactComponent };